import { createAssociatedTokenAccountInstruction, getAssociatedTokenAddress } from "@com.put/ppl-token"
import {
    PublicKey as PublicKey_put,
    Connection as Connection_put,
    TokenAmount as TokenAmount_put,
    Transaction as Transaction_put
} from "@com.put/web3.js"

interface SplTokenAmount extends TokenAmount_put {
    pubKey: PublicKey_put
}

export async function getTokenAccountFromOwner_put(connection: Connection_put, publicKeys: PublicKey_put[]): Promise<SplTokenAmount | null> {
    let account = null
    let tokenAccounts = await Promise.all(publicKeys.map(publicKey => connection.getTokenAccountBalance(publicKey)))

    for (let i = 0; i < tokenAccounts.length; ++i) {
        if (account === null || +tokenAccounts[i].value.amount >= +account?.amount) {
            account = {
                ...tokenAccounts[i].value,
                pubKey: publicKeys[i]
            }
        }
    }

    return account
}

export async function createTokenAccountTransaction({ payer, owner, mintPublicKey }: Record<"payer" | "owner" | "mintPublicKey", PublicKey_put>): Promise<{
    transaction: Transaction_put
    newAccountPubkey: PublicKey_put
}> {
    const ata = await getAssociatedTokenAddress(
        mintPublicKey,
        owner
    )
    const transaction = new Transaction_put()

    transaction.add(
        createAssociatedTokenAccountInstruction(
            payer,
            ata,
            owner,
            mintPublicKey
        )
    )
    return {
        transaction,
        newAccountPubkey: ata
    }
}
